import { AddHollow, Go, Team } from '@clearkit/icons';
import classnames from 'classnames';
import { CKBadge, CKButton } from 'clearkit';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { switchAccount } from '~/lib/account';
import history from '~/lib/history';

type AccountSwitchProps = {
  accounts: any[];
  currentAccountId: string;
};

const AccountSwitch: FC<AccountSwitchProps> = ({
  accounts,
  currentAccountId,
}) => {
  const handleManageTeam = () => {
    history.push('/team');
  };

  const buttonClasses =
    'block w-full px-4 py-1 text-left text-current group hover:bg-blue-0';

  return (
    <div className="py-3 overflow-y-auto text-sm font-medium text-gray-900 border-b border-gray-200 max-h-[60vh]">
      <ul className="grid gap-1">
        {accounts.map((account) => (
          <li key={account.id}>
            <button
              className={buttonClasses}
              onClick={() => {
                if (currentAccountId !== account.id) {
                  switchAccount(account.id);
                } else {
                  handleManageTeam();
                }
              }}
            >
              <span className="flex items-start w-full gap-2">
                <Team
                  className={classnames('h-4 w-4 text-gray-600 mt-0.5', {
                    'fill-gradient-br-blue': currentAccountId === account.id,
                  })}
                />
                <span className="grow">
                  <span className="block">{account.name}</span>
                  {currentAccountId === account.id && (
                    <span className="flex items-center ck-link !no-underline gap-1">
                      Manage team
                      <Go className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity duration-150 ease-out" />
                    </span>
                  )}
                </span>
                {currentAccountId === account.id && (
                  <CKBadge className="bg-gray-500" variant="rounded">
                    Current
                  </CKBadge>
                )}
              </span>
            </button>
          </li>
        ))}
        <li>
          <CKButton
            as={Link}
            className={buttonClasses}
            to="/profile/teams"
            variant="clear"
          >
            <span className="flex items-center gap-2">
              <AddHollow className="text-gray-600" />
              Create new team
            </span>
          </CKButton>
        </li>
      </ul>
    </div>
  );
};

export default AccountSwitch;
